import script from "./AgencyWebsiteFormStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyWebsiteFormStep2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__